import EmailScreen from './EmailScreen';

export default EmailScreen;